<template>
  <section>
    <div class="user__login">
      <div v-if="loginTypes.includes('all') || loginTypes.includes('local')">
        <form
          id="login"
          class="login-form"
          v-on:submit.prevent="validateBeforeSubmit"
          :action="`${identityApi}/login?redirectUrl=${this.redirectUrl}`"
          method="post"
        >
          <b-field
            :label="$t('email.name')"
            :type="{ 'is-danger': errors.has('email') }"
            :message="errors.first('email')"
          >
            <b-input
              type="text"
              v-model="email"
              name="email"
              v-validate="'required|email'"
            />
          </b-field>

          <b-field
            :label="$t('password.name')"
            :type="{ 'is-danger': errors.has('password') }"
            :message="errors.first('password')"
          >
            <b-input
              type="password"
              v-model="password"
              name="password"
              v-validate="'required'"
              password-reveal
            />
          </b-field>
          <button
            type="submit"
            class="button is-primary is-rounded action-button"
          >
            {{ $t("user.login") }}
          </button>
          <a class="forgetPassword" @click="$emit('forgotPassword')">{{
            $t("user.rememberPassword")
          }}</a>
        </form>
        <div class="seperator">
          <span class="seperator-text">{{ $t("user.or") }}</span>
        </div>
        <br />
      </div>
      <button
        v-if="tenant.tenantId === 'swisstxt'"
        @click="getIdentity('azureadoauth2')"
        class="loginBtn loginBtn--microsoft"
      >
        {{ $t("user.loginMicrosoft") }}
      </button>
      <button
        v-if="loginTypes.includes('all') || loginTypes.includes('facebook')"
        @click="getIdentity('facebook')"
        class="loginBtn loginBtn--facebook"
      >
        {{ $t("user.loginFacebook") }}
      </button>
      <button
        v-if="loginTypes.includes('all') || loginTypes.includes('google')"
        @click="getIdentity('google')"
        class="loginBtn loginBtn--google"
      >
        {{ $t("user.loginGoogle") }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      email: null,
      password: null,
      redirectUrl: null
    };
  },
  props: {
    loginTypes: {
      type: String,
      default: "all"
    }
  },
  created() {
    this.identityApi = `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
      process.env.VUE_APP_IDENTITY_API
    }`;
    this.redirectUrl = window.location.href;
    this.email = this.loginEmail;
  },
  computed: {
    ...mapGetters(["loginEmail", "tenant"])
  },
  methods: {
    ...mapMutations(["setLoginEmail"]),
    getIdentity(provider) {
      window.location.href = `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/${
        process.env.VUE_APP_IDENTITY_API
      }/${provider}?redirectUrl=${this.redirectUrl}`;
    },
    validateBeforeSubmit() {
      this.setLoginEmail(this.email);
      this.$validator.validateAll().then(result => {
        if (result) {
          document.getElementById("login").submit();
        } else {
          this.$buefy.toast.open({
            message: this.$t("user.loginNotValid"),
            type: "is-danger",
            position: "is-top-right"
          });
        }
      });
    }
  }
};
</script>
